import {BaseDataForwardsCollection} from "./_BaseDataForwardsCollection";

interface DataForwardsCollectionOptions {
    appId?: number;
}

export class DataForwardsCollection extends BaseDataForwardsCollection<Backbone.Model> {

    public appId: number;

    constructor(initialModels: Object[] | any[], options: DataForwardsCollectionOptions) {
        super(initialModels, options);

        this.appId = options.appId;
    }

    url = () => {
        // Here we use '/byAppId/' to prevent Express from considering any string after '/' as being an :appId
        return window.location.origin + '/api/v1/app/' + this.appUrlRoot + (this.appId ? ('/byAppId/' + this.appId) : '/');
    };

    comparator = (model) => {
        return model.get('name');
    };

}


// WEBPACK FOOTER //
// ./srv/public/js/apps/dataforwards/collections/DataForwards.ts